import PropTypes from 'prop-types';
import { userCoreInfoType } from '../common/types';

export const notificationType = PropTypes.shape({
  notificationId: PropTypes.string.isRequired,
  linkedUser: userCoreInfoType,
  createdAt: PropTypes.string
});
